import Button from 'components/button-new';
import { useState } from 'react';
import { gtm, selectElement } from 'tracking';

interface CollapsibleTextProps {
  text: string;
  previewWordCount?: number;
}

/**
 * A component that displays text in a collapsible format, showing a preview
 * with a configurable number of words before allowing expansion
 */
const CollapsibleText: React.FC<CollapsibleTextProps> = ({
  text,
  previewWordCount = 11,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const words = text.split(' ');
  const shouldCollapse = words.length > previewWordCount;
  const previewText = words.slice(0, previewWordCount).join(' ');

  return (
    <>
      <span className="mr-2 whitespace-pre-wrap">
        {shouldCollapse && !isExpanded ? `${previewText}...` : text}
      </span>
      {shouldCollapse && (
        <Button
          size="xs"
          layout="text"
          onClick={() => {
            gtm(
              selectElement({
                element: ['CollapsibleText'],
              })
            );
            setIsExpanded(!isExpanded);
          }}
          className="!w-auto"
          data-test="collapsible-text-toggle"
        >
          {isExpanded ? 'Weniger Infos' : 'Mehr Infos'}
        </Button>
      )}
    </>
  );
};

export default CollapsibleText;
